var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOsLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12,1C5.9,1,1,5.9,1,12s4.9,11,11,11s11-4.9,11-11S18.1,1,12,1z M12.9,21.1c-0.2-1.5-0.7-2.3-1.3-3 c-0.2-0.3-0.5-0.6-0.6-1.1c0-0.1,0-0.2-0.2-0.4l-0.1-0.1l-0.1,0c-0.4-0.1-0.7-0.2-1-0.3l-0.5-0.3v0.6c0,0.3,0,0.6,0.1,0.9 c0.2,0.6,0.5,1.1,0.8,1.5l0.1,0.2c0.4,0.6,0.8,1.1,0.9,2C8.1,20.8,5.5,19,4,16.4c-0.6-1.1-0.9-2.2-1-3.5c0.1-0.5,0.2-0.9,0.4-1.3 c1.1-2.1,3.1-3.6,5.4-4l0.6,0.1l0.1-0.6c0-0.2,0.1-0.3,0.3-0.5c0.2-0.2,0.3-0.3,0.6-0.4l0,0.1c-0.1,0.2-0.1,0.6-0.1,0.7 c0,0.4,0.1,1.1,0.8,1.7l6.6,4.4c0,0,0,0,0,0.1c0,0.1,0,0.1,0,0.1L17.4,14c-0.3,0.5-1,0.7-1.6,0.3L15.3,14c-0.7-0.5-1.6-0.4-2.2,0.1 l-0.5,0.4c-0.7,0.3-1.4,0.3-2.1,0.1l-0.3-0.1c-0.7-0.4-1.1-1.1-1.1-1.9c0,0,0-0.1,0-0.2c0-0.1,0-0.2,0-0.2l0.3-0.8l-0.2-0.1 c-0.3-0.2-0.5-0.4-0.8-0.6l-0.3-0.3L8,10.6c-0.2,0.3-0.3,0.7-0.4,1.1c-0.1,0.2-0.1,0.5-0.1,0.7c0,1.4,0.7,2.7,1.9,3.4 c0.4,0.2,0.7,0.3,1.1,0.5l0.1,0c0,0,0.1,0,0.2,0c0.1,0,0.2,0,0.2,0c0.2,0,0.3,0,0.5,0c1,0,2-0.4,2.8-1.1c0.1-0.1,0.1-0.1,0.2,0 l0.6,0.4c0.6,0.4,1.4,0.6,2.1,0.4c0.7-0.2,1.4-0.6,1.8-1.2l0.4-0.6c0.5-0.9,0.3-2-0.5-2.5l-6.5-4.3c-0.3-0.2-0.2-0.7-0.2-0.7 l0.5-2.1l-0.9-0.1c-1.9-0.2-3,0.6-3.5,1.6C6.5,6.5,4.9,7.3,3.6,8.7L3.5,8.8C4.8,5.4,8.1,2.9,12,2.9c5,0,9.1,4.1,9.1,9.1 C21.1,16.7,17.5,20.6,12.9,21.1z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOsLogo);
export default __webpack_public_path__ + "static/media/os-logo.2511805e.svg";
export { ForwardRef as ReactComponent };